import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Box, DialogContent, DialogContentText } from "@mui/material";
import useStyles from "../../../../components/common/model/styles";
import Popup from "../../../../components/common/model/Popup";
import CustomButton from "../../../../components/common/button/CustomButton";
import Notification from "../../../../components/common/notification/Notification";
import closeIcon from "../../../../assets/closeModel.png";
import {
  getSingleLeadCompletionNotesAction,
  setUpdatedCompletedFeedbackResponse,
  updatedCompletedFeedbackAction,
} from "../../../../store/reducers/feedbackSlice";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import { getSingleLeadAction } from "../../../../store/reducers/leadSlice";
import { getInvoiceListByCustomerIdAction } from "../../../../store/reducers/invoiceSlice";
import PendingInvoiceList from "./PendingInvoiceList";

interface ManageCompletionProps {
  open: boolean;
  onHide: () => void;
  title: string;
  leadDetails?: any; // Adjust as per your type definitions
}

const ManageCompletion: React.FC<ManageCompletionProps> = ({
  open,
  onHide,
  title,
  leadDetails,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { isUpdatedCompletedFeedbackResponse } = useSelector(
    (state: any) => state.feedback
  );

  const { customerInvoices } = useSelector((state: any) => state.invoice);

  const [formData, setFormData] = useState({
    lead_id: "",
    new_status: "COMPLETED",
  });

  const [fullWidth] = useState(true);
  const [maxWidth] = useState<"sm" | "xs" | "md" | "lg" | "xl" | false>("sm");

  useEffect(() => {
    if (open) {
      dispatch(
        getInvoiceListByCustomerIdAction({
          customerId: leadDetails?.lead?.generated_id,
        })
      );
    }
  }, [open]);

  useEffect(() => {
    if (leadDetails) {
      setFormData({
        lead_id: leadDetails?.lead?.generated_id || "",
        new_status: "COMPLETED",
      });
    }
  }, [leadDetails]);

  const handleSubmit = () => {
    if (formData?.lead_id) {
      dispatch(updatedCompletedFeedbackAction(formData));
    }
  };

  useEffect(() => {
    if (isUpdatedCompletedFeedbackResponse) {
      console.log("API calling for lead notes -62");
      setFormData({ lead_id: "", new_status: "COMPLETED" });
      dispatch(getSingleLeadAction(leadDetails?.lead?.generated_id));
      dispatch(
        getSingleLeadCompletionNotesAction(leadDetails?.lead?.generated_id)
      );
      dispatch(setUpdatedCompletedFeedbackResponse(false));
      onHide();
      dispatch(setNotificationAction({ message: [], severity: "error" }));
    }
  }, [isUpdatedCompletedFeedbackResponse, dispatch, onHide]);

  const handleClose = () => {
    onHide();
    setFormData({
      lead_id: leadDetails?.lead?.generated_id || "",
      new_status: "COMPLETED",
    });
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  return (
    <Popup
      open={open}
      title={title}
      onHide={handleClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      aria-describedby="alert-dialog-slide-description"
      header={
        <img
          onClick={handleClose}
          src={closeIcon}
          className={classes.closeicons}
          alt="close"
        />
      }
      footer={
        <>
          <CustomButton variant="outlined" title="No" onClick={handleClose} />
          <CustomButton title="Yes" onClick={handleSubmit} />
        </>
      }
    >
      <DialogContent sx={{ padding: "0px" }}>
        <DialogContentText>
          <Notification />
          {customerInvoices?.length > 0 &&
            customerInvoices?.some(
              (val: any) => val?.status?.toUpperCase() !== "PAID"
            ) && (
              <Box
                sx={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  padding: "16px",
                }}
              >
                <PendingInvoiceList invoices={customerInvoices} />
              </Box>
            )}
          <Alert
            sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
            severity="warning"
          >
            Clicking on complete will mark the lead as closed. Do you want to
            proceed?
          </Alert>
        </DialogContentText>
      </DialogContent>
    </Popup>
  );
};

export default ManageCompletion;
